import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface VehicleType {
    _id: string;
    designation: string;
    price: number;
    priceType: number;
    crudStatus: number;
    usageCount?: {
        total: number;
        vehicles: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

export interface VehicleTypesResponse {
    message: string;
    data: VehicleType[];
}

export interface VehicleTypeResponse {
    message: string;
    data: VehicleType;
}

export interface GetVehiclesTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateVehicleTypeBody {
    designation: string;
    price: number;
    priceType: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export interface UpdateVehicleTypeBody {
    designation?: string;
    price?: number;
    priceType?: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export const getAllVehicleTypes = async (queries?: GetVehiclesTypesQueries): Promise<VehicleTypesResponse> => {
    try {
        const response: AxiosResponse<VehicleTypesResponse> = await apiClient.get('/vehicle-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const createVehicleType = async (data: CreateVehicleTypeBody): Promise<VehicleTypeResponse> => {
    try {
        const response: AxiosResponse<VehicleTypeResponse> = await apiClient.post('/vehicle-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const updateVehicleType = async (id: string, data: UpdateVehicleTypeBody): Promise<VehicleTypeResponse> => {
    try {
        const response: AxiosResponse<VehicleTypeResponse> = await apiClient.patch(`/vehicle-types/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
